// extracted by mini-css-extract-plugin
export default {"root":"TabItem_root__RaUTA","active":"TabItem_active__hEY0e","disabled":"TabItem_disabled__rqId1","placeHolderShimmer":"TabItem_placeHolderShimmer__Gv-B9"};